import React from 'react';
import { Layout, Typography, Badge, Button, theme, Grid, Space } from 'antd';
import { ShoppingCartOutlined, UserOutlined, DashboardOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectCartItemsCount } from '../../store/slices/cartSlice';

const { Header: AntHeader } = Layout;
const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

const Header = () => {
  const navigate = useNavigate();
  const screens = useBreakpoint();
  const { token } = theme.useToken();
  const cartItemsCount = useSelector(selectCartItemsCount);
  const user = useSelector((state) => state.auth.user);

  return (
    <AntHeader
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: screens.md ? '0 24px' : '0 12px',
        background: token.colorBgContainer,
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        height: 64,
      }}
    >
      <div
        onClick={() => navigate('/')}
        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
      >
        <Title
          level={4}
          style={{
            margin: 0,
            color: token.colorPrimary,
            fontSize: screens.md ? 20 : 16,
            whiteSpace: 'nowrap'
          }}
        >
          {screens.xs ? 'Megadent' : 'Megadent Shop'}
        </Title>
      </div>

      <Space size={screens.md ? "middle" : "small"} align="center">
        {user?.role === 'admin' && (
          <Button
            type={screens.md ? "primary" : "text"}
            icon={<DashboardOutlined />}
            onClick={() => navigate('/admin')}
            title="Admin Panel"
            size={screens.md ? 'middle' : 'small'}
          >
            {screens.md ? 'Admin' : ''}
          </Button>
        )}

        {user?.role === 'seller' && (
          <Button
            type={screens.md ? "primary" : "text"}
            icon={<DashboardOutlined />}
            onClick={() => navigate('/seller')}
            title="Sotuvchi Panel"
            size={screens.md ? 'middle' : 'small'}
          >
            {screens.md ? 'Sotuvchi' : ''}
          </Button>
        )}


        <Badge count={cartItemsCount} size="small">
          <div id="global-cart-icon" style={{ display: 'inline-block' }}>
            <Button
              type="text"
              icon={<ShoppingCartOutlined style={{ fontSize: '20px' }} />}
              onClick={() => navigate('/cart')}
            />
          </div>
        </Badge>

        <div onClick={() => navigate('/profile')} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
          {user && screens.md && (
            <Text strong style={{ marginRight: 8, maxWidth: 100, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
              {user.first_name}
            </Text>
          )}
          <Button
            type="text"
            icon={<UserOutlined style={{ fontSize: '20px' }} />}
          />
        </div>
      </Space>
    </AntHeader >
  );
};

export default Header;
